export const profileConstants = {
    SESSION_ID: 'PROFILE_SESSION_ID',

    WEBPUSH_SUSCRIBE_REQUEST: 'WEBPUSH_SUSCRIBE_REQUEST',
    WEBPUSH_SUSCRIBE_SUCCESS: 'WEBPUSH_SUSCRIBE_SUCCESS',
    WEBPUSH_SUSCRIBE_FAILURE: 'WEBPUSH_SUSCRIBE_FAILURE',

    INIT: 'PROFILE_INIT',
    INITIED: 'PROFILE_INITIED',

    DO_NOT_DISTURB: 'PROFILE_DO_NOT_DISTURB',

    ROOM_OCCUPATION_UPDATED: 'ROOM_OCCUPATION_UPDATED',

    CONSUMPTIONS_REQUEST: 'CONSUMPTIONS_REQUEST',
    CONSUMPTIONS_SUCCESS: 'CONSUMPTIONS_SUCCESS',
    CONSUMPTIONS_FAILURE: 'CONSUMPTIONS_FAILURE',

    NOTIFICATIONS_REQUEST: 'NOTIFICATIONS_REQUEST',
    NOTIFICATIONS_SUCCESS: 'NOTIFICATIONS_SUCCESS',
    NOTIFICATIONS_FAILURE: 'NOTIFICATIONS_FAILURE',

    CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',

    RESET: 'PROFILE_RESET'
};